var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfessionSixt = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "60px",
    viewBox: "0 0 54 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Sixtbook_Profile",
    transform: "translate(-460.000000, -725.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "center",
    transform: "translate(430.000000, 470.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "professional",
    transform: "translate(0.000000, 140.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(30.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "marker/blank/active",
    fill: "#FF5000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "33.9991179 53.1147541 27 60 20.0064438 53.1147541 0 53.1147541 0 0 54 0 54 53.1147541"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(6.000000, 19.000000)",
    fill: "#191919"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7349044,7.14826407 L18.7349044,15.0687204 L22.7259221,9.14201975 L20.8540095,6.69025688 C22.4178082,6.2587659 23.8374113,5.59125878 25.0751264,4.622212 L26.2810659,6.14919481 L28.5693487,2.69244584 L41.5708359,2.69244584 L41.5708359,6.61596768 L38.6459451,6.61596768 L38.6459451,16.1920433 L28.5684721,16.1957687 L25.9896068,12.3425915 L23.3088403,16.1957687 L13.8283107,16.1957687 L13.8283107,13.5612412 C13.1467785,15.424169 10.9954596,16.5588873 6.73029506,16.5588873 C0.403440779,16.5588873 0.0966417076,14.3225412 1.98951966e-13,11.7612073 L5.00323543,11.7612073 C5.01945195,12.5257944 5.14852671,13.080005 5.45532578,13.4431236 C5.77812223,13.8064613 6.21377691,13.9975533 6.85936981,13.9975533 C7.87618959,13.9975533 8.9736537,13.7109154 8.9736537,12.6020559 C8.9736537,12.3537677 8.89300937,12.1433912 8.76393462,11.9713646 C8.1021252,11.0921661 2.53394119,10.4424095 0.968389355,8.8176893 C0.338793832,8.16771356 0.145072132,7.19296908 0.145072132,6.40931659 C0.145072132,3.38931802 2.48551076,2.03217041 7.14995236,2.03217041 C12.1049765,2.03217041 13.2780447,3.76646173 13.3424725,6.61443368 L8.5244122,6.61443368 C8.4921983,5.84984657 8.26297557,5.25268409 7.92724973,4.97568836 C7.60248099,4.7078966 7.32088327,4.58364297 6.82715591,4.59350437 C5.79433875,4.61366545 5.24538756,5.05216898 5.24538756,5.75934084 C5.24538756,5.96949821 5.3100345,6.23728997 5.45532578,6.39003208 C6.21377691,7.25016519 11.6046749,7.86179105 13.1540102,9.50579579 C13.4001069,9.76591758 13.6508055,10.1053688 13.8283107,10.5765246 L13.8283107,7.39786703 C15.4289253,7.45725456 17.0941868,7.40487958 18.7349044,7.14826407 L18.7349044,7.14826407 Z M31.3853259,6.6264865 L29.5550503,9.19724358 L33.7840563,15.3820937 L33.7840563,6.6264865 L31.3853259,6.6264865 Z",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8273027,2.90341493 C18.8235256,3.27135467 21.6362156,1.85744924 22.601537,2.66453526e-15 L27.7029481,2.66453526e-15 C26.1685145,4.43565715 21.3848595,7.21459931 13.8273027,6.8343876 L13.8273027,2.90341493 Z",
    id: "Fill-10"
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfessionSixt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/profession_sixt.608fdf7b91aadc9e77e3d08b3e4678dd.svg";